import React, { useEffect, useMemo, useState } from "react";
import { loader } from "graphql.macro";
import { useQuery } from "../../../hooks/useQuery";
import { TournamentBoard } from "./TournamentBoard";
import { TournamentRounds } from "./TournamentRounds";
import {
  TableOperation,
  TournamentPlayerPerTeam,
  TournamentStatus,
  TournamentType,
} from "../../../graphql/generated";
import { useLocation, useParams } from "react-router";
import { Link, Redirect, useHistory } from "react-router-dom";
import { useSubscription } from "../../../hooks/useSubscription";
import {
  ScheduledTournamentSubscription,
  ScheduledTournamentSubscriptionVariables,
} from "./graphql/ScheduledTournamentSubscription.generated";
import {
  ScheduledTournamentQuery,
  ScheduledTournamentQueryVariables,
} from "./graphql/CurrentScheduledTournamentQuery.generated";
import { ScheduledTournamentBoard } from "./ScheduledTournamentBoard";
import { ScheduledTournamentRounds } from "./ScheduledTournamentRounds";

const SCHEDULED_TOURNAMENT_QUERY = loader(
  "./graphql/CurrentScheduledTournamentQuery.graphql"
);

const SCHEDULED_TOURNAMENT_SUBSCRIPTION = loader(
  "./graphql/ScheduledTournamentSubscription.graphql"
);

export const CurrentScheduledTournaments = () => {
  const { sectionId, tournamentId } = useParams<{
    sectionId: string;
    tournamentId: string;
  }>();
  const { push } = useHistory();

  const [
    tournamentStatus,
    setTournamentStatus,
  ] = useState<TournamentStatus | null>();

  const variables = useMemo(() => {
    return { id: tournamentId };
  }, [tournamentId]);

  const filterData = React.useMemo(() => {
    return {
      roomId: sectionId?.split(":")[0],
      gameId: sectionId?.split(":")[1],
    };
  }, [sectionId]);

  const [{ data, fetching, error }] = useQuery<
    ScheduledTournamentQuery,
    ScheduledTournamentQueryVariables
  >({
    query: SCHEDULED_TOURNAMENT_QUERY,
    variables,
    throwOnError: false,
    requestPolicy: "network-only",
  });

  useEffect(() => {
    if (!fetching && error) {
      push(`/area/${filterData?.roomId}:${filterData.gameId}/my-tournaments`);
    }
  }, [fetching, error]);

  const [{ data: subscriptionData }] = useSubscription<
    unknown,
    ScheduledTournamentSubscription,
    ScheduledTournamentSubscriptionVariables
  >({
    query: SCHEDULED_TOURNAMENT_SUBSCRIPTION,
    variables,
    throwOnError: false,
  });

  useEffect(() => {
    if (subscriptionData) {
      if (
        subscriptionData.scheduledTournament?.__typename ===
        "ScheduledTournamentEntityUpdate"
      ) {
        const tournament = subscriptionData?.scheduledTournament?.tournament;

        setTournamentStatus(tournament?.status!);
      }
    }
  }, [subscriptionData]);

  useEffect(() => {
    if (data?.scheduledTournament)
      setTournamentStatus(data?.scheduledTournament?.status);
  }, [data]);

  const handleCloseShowTournament = () => {
    push(`/area/${filterData?.roomId}:${filterData.gameId}/my-tournaments`);
  };

  if (tournamentId) {
    if (
      tournamentStatus === TournamentStatus.Upcoming ||
      tournamentStatus === TournamentStatus.Draw
    ) {
      return (
        <ScheduledTournamentBoard
          onClose={handleCloseShowTournament}
          tournamentId={tournamentId}
          roomId={filterData.roomId}
        />
      );
    }
    if (
      tournamentStatus === TournamentStatus.Ongoing ||
      tournamentStatus === TournamentStatus.Completed ||
      tournamentStatus === TournamentStatus.Cancelled
    ) {
      return (
        <ScheduledTournamentRounds
          onClose={handleCloseShowTournament}
          tournamentId={tournamentId}
          roomId={filterData.roomId}
        />
      );
    }
  }

  return <></>;
};
